import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GuestWelcomeGuard } from '../../guards/guest-welcome.guard';

export const admin: Routes = [
  {
    path: 'welcome',
    loadComponent: () => import('./guest-welcome.component').then((m) => m.GuestWelcomeComponent),
    canActivate: [GuestWelcomeGuard],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class guestWelcomeRoutingModule {
  static routes = admin;
}
